import { PageIndicatorActiveContent, PageIndicatorContainer } from './styles';

export const PageIndicator = ({ active }: { active: boolean }) => {
	return (
		<PageIndicatorContainer active={active}>
			{active && <PageIndicatorActiveContent />}
		</PageIndicatorContainer>
	);
};
